import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SvgIconComponent } from 'src/app/shared/components/svg-icon/svg-icon.component';
import { MaterialModule } from 'src/app/shared/material.module';
import { ActionIcons, popupButtons } from 'src/app/shared/utility/constants';
import { toApiDateString } from 'src/app/shared/utility/invoice-date.util';

@Component({
  selector: 'app-invoiced-date-popup',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MaterialModule, SvgIconComponent],
  templateUrl: './invoiced-date-popup.component.html',
  styleUrl: './invoiced-date-popup.component.scss',
})
export class InvoicedDatePopupComponent {
  private readonly dialogRef = inject(MatDialogRef<InvoicedDatePopupComponent>);
  public readonly data: { title: string } = inject(MAT_DIALOG_DATA);
  public readonly actionIcons = ActionIcons;
  public readonly popupButtons = popupButtons;
  public readonly invoicedDate = new FormControl<Date | null>(new Date(), Validators.required);
  public readonly minDate = new Date(new Date().setMonth(new Date().getMonth() - 6));
  public readonly maxDate = new Date(new Date().setMonth(new Date().getMonth() + 1));

  public onCancel(): void {
    this.dialogRef.close();
  }

  public onProceed(): void {
    const invDate = toApiDateString(this.invoicedDate.value);
    if (invDate) {
      this.dialogRef.close(invDate);
    }
  }
}
